var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pa-0",attrs:{"fluid":""}},[_c('v-row',[_c('v-col',[_c('entrance-table-form')],1)],1),_c('v-row',[_c('v-col',[_c('printer-table-form')],1)],1),_c('v-row',[_c('v-col',[_c('device-table-form')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }